import { render } from "./StoryForm.vue?vue&type=template&id=40f4eaa1&scoped=true&ts=true"
import script from "./StoryForm.vue?vue&type=script&lang=ts"
export * from "./StoryForm.vue?vue&type=script&lang=ts"

import "./StoryForm.vue?vue&type=style&index=0&id=40f4eaa1&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f4eaa1"]])

export default __exports__